import React from 'react';
import BlogPostItem from '@/components/BlogPostItem';
import Button from '@/components/Button';
import { useTranslation } from 'next-i18next';
import Title from '@/components/Title';
import useGTM from '@/hooks/useGtag';
import { traceEvent } from '@wk/wk-gatherer';
import { Post } from '@/request/interface/common';
import useBlogList from '@/hooks/useBlogList';

const Index = () => {
  const { t, i18n } = useTranslation(['whyWukong']);
  const { blogList: eduBlogList, isStore } = useBlogList({
    storeName: `blog-list-why-wukong-${i18n.language}`,
    cat_id: i18n.language === 'zh' ? '135942' : '135940',
  });
  const { blogList: storyBlogList } = useBlogList({
    storeName: `blog-list-why-wukong-${i18n.language}`,
    cat_id: i18n.language === 'zh' ? '135946' : '135944',
  });
  let blogList = eduBlogList?.length ? eduBlogList : storyBlogList;
  if (eduBlogList.length >= 2 && storyBlogList.length >= 1 && !isStore) {
    blogList = [eduBlogList[0], eduBlogList[1], storyBlogList[0]];
  }

  const sendDataToGTM = useGTM();
  const handleGA = (gaName?: string, extra: { [key: string]: any } = {}) => {
    // 获取当前路径
    const gaNameFix = `O_WhyWuKong_BlogModule_${gaName}`;
    sendDataToGTM(gaNameFix);
    traceEvent({
      data: {
        _event: gaNameFix,
        ...extra,
      },
    });
  };

  const handleClick = (data: Post) => {
    handleGA('ArticleClick', {
      article_name: data?.post_title,
      article_type: data?.post_id,
      Article_url: data?.post_link,
    });
  };

  return (
    <div className=" container mb-[100px] mt-20 lg:mb-[120px] lg:mt-[140px] xl:mb-[150px] xl:mt-[180px]">
      <Title className="" innerHTML theme="colorful">
        {`${t('理由-博客-标题')} <div class=' lg:inline-block relative  lg:after:h-[122px] lg:after:w-[122px] xl:after:h-[188px] xl:after:w-[188px] after:bg-[url("/images/home/userReviews-icon.png")] after:bg-cover after:bg-no-repeat lg:after:block after:absolute lg:after:top-[-77px]  lg:after:right-[-104px] xl:after:top-[-120px]  xl:after:right-[-150px]' />`}
      </Title>
      <p className="subTitleMaxWidth my-6 text-center text-base leading-normal text-wk-words-1 lg:mb-[44px] lg:text-xl xl:mb-15 xl:mt-10 xl:text-[28px] xl:leading-[46px]">
        {t('理由-博客-介绍')}
      </p>
      <BlogPostItem post={blogList} handleClick={handleClick} />
      <div className="text-center">
        <Button
          href={t('path:博客')}
          target="_blank"
          size="xl"
          className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
          traceName="O_WhyWuKong_BlogModule_MoreClick"
        >
          {t('home:博客-按钮')}
        </Button>
      </div>
    </div>
  );
};

export default Index;
